export default "__VITE_ASSET__25464eac__"